export const SUPPORTED_SLIDESHOW_LOCALES = ["en", "es", "fr"];
export const resolveLocale = (locale) => {
    const requestedLocale = Array.isArray(locale) ? locale[0] : locale;
    const languageCode = requestedLocale?.split("-")[0]?.toLowerCase();
    return (SUPPORTED_SLIDESHOW_LOCALES.find(supportedLocale => supportedLocale === languageCode) ?? "en");
};
